module.exports = __webpack_public_path__ + "img/icon_rotate_right.6f112737.svg";